import { useState } from "react";
import { useNotify, useRecordContext } from "react-admin";
import DescriptionIcon from "@mui/icons-material/Description";
import { Backdrop, Button, CircularProgress, Tooltip } from "@mui/material";

import { erasmusRequests } from "api/erasmusApi";
import { settings } from "app";
import { getFileFromUrl } from "server/components/DownloadFile";
import { ERASMUS_BUSINESS_TRIP_REPORT_STATUSES } from "utils/constants";

const LABEL = "Доклад за командировка";

const BusinessTripReportButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  if (!record) return null;

  const blockedReason = !ERASMUS_BUSINESS_TRIP_REPORT_STATUSES.includes(record.status)
    ? "Докладът е наличен след одобрение от интервюто."
    : !record.absenceStartDate || !record.absenceEndDate
      ? "Задайте период на отсъствие, за да свалите доклада."
      : null;

  if (blockedReason) {
    return (
      <Tooltip title={blockedReason}>
        {/* the disabled button has pointer-events: none, so the span must carry the hover area */}
        <span>
          <Button
            sx={{ width: "max-content" }}
            variant="contained"
            size="medium"
            startIcon={<DescriptionIcon />}
            disabled
          >
            {LABEL}
          </Button>
        </span>
      </Tooltip>
    );
  }

  const handleDownload = async () => {
    setLoading(true);

    await getFileFromUrl(
      `${settings.gatewayApi}/${erasmusRequests.getBusinessTripReport(record.id)}`,
      `business-trip-report-${record.id}.pdf`,
      notify,
    );

    setLoading(false);
  };

  return (
    <>
      <Button
        sx={{ width: "max-content" }}
        variant="contained"
        size="medium"
        startIcon={<DescriptionIcon />}
        onClick={handleDownload}
        disabled={loading}
      >
        {LABEL}
      </Button>
      <Backdrop
        sx={{ zIndex: 10000 }}
        open={loading}
      >
        <CircularProgress
          color="primary"
          size={60}
        />
      </Backdrop>
    </>
  );
};

export default BusinessTripReportButton;
